/* IssueTextNode.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./IssueTextNode.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useRef } from 'react';
import { Box, Text } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip';
var styles = {
  container: "_1bsb1osq"
};
export var IssueTextNode = function IssueTextNode(_ref) {
  var text = _ref.text;
  var textRef = useRef(null);
  if (!text) {
    return /*#__PURE__*/React.createElement(Text, null, "\xA0");
  }
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: text
    // don't need a screen reader announcement as the
    // tooltip content is the same as the items content
    ,
    isScreenReaderAnnouncementDisabled: true,
    canAppear: function canAppear() {
      var element = textRef.current;

      // Only showing the tooltip for this item when
      // the element has been clamped.
      return !!element && element.scrollHeight > element.clientHeight;
    }
  }, function (props) {
    return /*#__PURE__*/React.createElement(Box, _extends({}, props, {
      xcss: styles.container
    }), /*#__PURE__*/React.createElement(Text, {
      ref: textRef,
      maxLines: 1
    }, text));
  });
};